var _path, _path2, _rect, _rect2, _circle, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.782 5.7666C9.06633 5.7666 6.04669 8.78625 6.04669 12.5019V15.746C6.04669 16.4308 5.75483 17.4747 5.40684 18.0585L4.11591 20.2025C3.31891 21.5271 3.86895 22.9977 5.32826 23.4916C10.1664 25.108 15.3863 25.108 20.2244 23.4916C21.5827 23.0426 22.1777 21.4373 21.4368 20.2025L20.1458 18.0585C19.8091 17.4747 19.5172 16.4308 19.5172 15.746V12.5019C19.5172 8.79747 16.4864 5.7666 12.782 5.7666Z",
    fill: "#EE0033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1858 25.9849C13.9698 26.398 11.604 26.4072 9.32275 25.9849C9.32275 27.669 11.3012 28.7586 12.9071 28.8338C14.9127 28.9276 16.1858 27.5319 16.1858 25.9849Z",
    fill: "#EE0033"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 2.5,
    width: 16.25,
    height: 16.25,
    rx: 8.125,
    fill: "#EE0033"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 2.5,
    width: 16.25,
    height: 16.25,
    rx: 8.125,
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2026,
    cy: 10.625,
    r: 6.875,
    fill: "#EE0033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9707 9.19014C20.7515 9.19014 20.5512 9.36196 20.5609 9.58092C20.5713 9.81543 20.3842 10.0088 20.152 10.0088H19.3333C19.1072 10.0088 18.924 9.82556 18.924 9.59948C18.924 9.37341 18.7407 9.19014 18.5146 9.19014H17.6959C17.3719 9.19014 17.0604 9.24393 16.7699 9.34307C15.6419 9.7281 14.8306 10.7971 14.8306 12.0555C14.8306 13.638 16.1135 14.9209 17.6959 14.9209C17.7921 14.9209 19.8033 14.9341 20.3974 12.9031C20.6101 12.1761 21.2313 11.6462 21.9887 11.6462H23.6723C24.1245 11.6462 24.491 11.2796 24.491 10.8275V10.0088C24.491 9.55669 24.1245 9.19014 23.6723 9.19014H20.9707Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6958 13.2808C18.3716 13.2808 18.9212 12.7319 18.9214 12.0562C18.9214 11.3802 18.3718 10.8306 17.6958 10.8306C17.02 10.8308 16.4712 11.3803 16.4712 12.0562C16.4714 12.7318 17.0202 13.2805 17.6958 13.2808Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6606 5.91521V6.73389",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9243 6.97385L18.5032 7.55273",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3972 6.97385L20.8184 7.55273",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fdfc2a321aa57edcb32a7a79e0d13af3.svg";
export { ForwardRef as ReactComponent };